import validator from 'validator'
/* 表单校验规则方法命名以Rule为结尾，方便和一般的校验区分*/

export default {
  /*  是否数字*/
  validateNumberRule(value) {
    if (value === undefined || value === null || value === '') {
      return true
    }
    if (!validator.isNumeric('' + value)) {
      return false
    } else {
      return true
    }
  },
  /*  是否数字大于0*/
  validateNumberGTZRule(value) {
    if (value === undefined || value === null || value === '') {
      return true
    }
    if (validator.isNumeric('' + value, [{ no_symbols: false }]) && value > 0) {
      return true
    } else {
      return false
    }
  },
  /*  是否整数*/
  validateIntegerRule(value) {
    if (value === undefined || value === null || value === '') {
      return true
    }
    if (!validator.isInt('' + value)) {
      return false
    } else {
      return true
    }
  },
  /*  是否整数大于0*/
  validateIngeterGTZRule(value) {
    if (value === undefined || value === null || value === '') {
      return true
    }
    if (!validator.isInt('' + value, { gt: 0 })) {
      return false
    } else {
      return true
    }
  },
  /*  是否字母*/
  validateAlphaRule(value) {
    if (value === undefined || value === null || value === '') {
      return true
    }
    if (!validator.isAlpha(value, 'en-US')) {
      return false
    } else {
      return true
    }
  },

  /*  是否身份证号码*/
  validateIdNoRule(value) {
    if (value === undefined || value === null || value === '') {
      return true
    }
    const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
    if (value === '' || value === undefined || value === null) {
      return true
    } else {
      if ((!reg.test(value)) && value !== '') {
        return false
      } else {
        return true
      }
    }
  },
  /*  是否身份证号码,详细规则校验*/
  validateIdNoStrictRule(code) {
    if (code === undefined || code === null || code === '') {
      return true
    }
    var city = { 11: '北京', 12: '天津', 13: '河北', 14: '山西', 15: '内蒙古', 21: '辽宁', 22: '吉林', 23: '黑龙江 ',
      31: '上海', 32: '江苏', 33: '浙江', 34: '安徽', 35: '福建', 36: '江西', 37: '山东', 41: '河南', 42: '湖北 ',
      43: '湖南', 44: '广东', 45: '广西', 46: '海南', 50: '重庆', 51: '四川', 52: '贵州', 53: '云南', 54: '西藏 ',
      61: '陕西', 62: '甘肃', 63: '青海', 64: '宁夏', 65: '新疆', 71: '台湾', 81: '香港', 82: '澳门', 91: '国外 ' }
    var pass = true

    if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
      pass = false
    } else if (!city[code.substr(0, 2)]) {
      pass = false
    } else {
      // 18位身份证需要验证最后一位校验位
      if (code.length === 18) {
        code = code.split('')
        // ∑(ai×Wi)(mod 11)
        // 加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        // 校验位
        var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
        var sum = 0
        var ai = 0
        var wi = 0
        for (var i = 0; i < 17; i++) {
          ai = code[i]
          wi = factor[i]
          sum += ai * wi
        }
        if (parity[sum % 11] !== code[17]) {
          pass = false
        }
      }
    }
    if (!pass) {
      return false
    } else {
      return true
    }
    // if (!pass) alert(tip)
    // return pass
  },
  /*  是否URL*/
  validateURLRule(value) {
    if (value === undefined || value === null || value === '') {
      return true
    }
    if (!validator.isURL(value)) {
      return false
    } else {
      return true
    }
  },
  /*  是否邮箱*/
  validateEMailRule(value) {
    if (value === undefined || value === null || value === '') {
      return true
    }
    const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/
    if (value === '' || value === undefined || value === null) {
      return true
    } else {
      if (!reg.test(value)) {
        return false
      } else {
        return true
      }
    }
  },
  /*  是否手机号码*/
  validateMobileRule(value) {
    if (value === undefined || value === null || value === '') {
      return true
    }
    const reg = /^[1][3,4,5,7,8,9][0-9]{9}$/
    if (value === '' || value === undefined || value === null) {
      return true
    } else {
      if ((!reg.test(value)) && value !== '') {
        return false
      } else {
        return true
      }
    }
  },
  /*  是否手机号码或者固话*/
  validateTelOrMobileRule(value) {
    if (value === undefined || value === null || value === '') {
      return true
    }
    const reg = /^((0\d{2,3}-\d{7,8})|(1[34578]\d{9}))$/
    if (value === '' || value === undefined || value === null) {
      return true
    } else {
      if ((!reg.test(value)) && value !== '') {
        return false
      } else {
        return true
      }
    }
  },
  /*  是否固话*/
  validateTelphoneRule(value) {
    if (value === undefined || value === null || value === '') {
      return true
    }
    const reg = /0\d{2}-\d{7,8}/
    if (value === '' || value === undefined || value === null) {
      return true
    } else {
      if ((!reg.test(value)) && value !== '') {
        return false
      } else {
        return true
      }
    }
  },

  /*  是否合法IP地址*/
  validateIPRule(value) {
    if (value === '' || value === undefined || value === null) {
      return true
    } else {
      const reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
      if ((!reg.test(value)) && value !== '') {
        return false
      } else {
        return true
      }
    }
  }
}

